var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYellowWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m18.612 14.126-7.455-12.94c-.912-1.581-2.4-1.581-3.313 0L.389 14.126C-.523 15.708.224 17 2.046 17h14.91c1.821 0 2.565-1.292 1.656-2.874zM8.475 4.858c.27-.29.609-.435 1.026-.435.417 0 .756.142 1.025.43.263.284.4.644.4 1.076 0 .369-.556 3.097-.742 5.08h-1.34c-.163-1.983-.768-4.711-.768-5.08 0-.426.136-.783.4-1.07zm2.03 9.434c-.28.273-.616.412-1.004.412s-.724-.14-1.005-.412a1.344 1.344 0 0 1-.42-.999c0-.389.139-.725.42-1.007a1.37 1.37 0 0 1 1.005-.42c.388 0 .724.139 1.005.42.28.282.42.618.42 1.007 0 .392-.14.723-.42.999z",
    fill: "#FFB93A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowWarning);
export default __webpack_public_path__ + "static/media/yellowWarning.f0a74337788def65081c922d3dbda5d5.svg";
export { ForwardRef as ReactComponent };